import '../App.css'
import { useEffect} from "react";
import NavBar from "../components/NavBar/NavBar";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer/Footer";
import { useDispatch, useSelector } from "react-redux";
import * as userActions from "../redux/user/userActions"
import * as usersListActions from "../redux/listUsers/listUsersActions"
import Spinner from "../components/Spinner/Spinner";
import ListUsersBody from '../components/ListUsersBody/ListUsersBody';
import URLPage from "../endPoints/endpoints";



function ListUsers() {

  const navigate = useNavigate();
  const currentUser = useSelector(state => state.us.current)
  const listUsers = useSelector(state => state.usersList.users?.users);
  const navBar = useSelector(state => state.navbar.navbar);

  
  
  const dispatch = useDispatch();
  
  useEffect(() => {
    const fetchUsers = async () => {
      try {


        const response = await axios.get(`${URLPage}/api/users/list-users`, {
          headers: {
            "x-token": currentUser.token,
          },
        });

        
        dispatch(usersListActions.setUsersList(response.data));
      } catch (error) {
        navigate('/')
        dispatch(usersListActions.setUsersList(null));
        dispatch(userActions.setCurrentUser(null));
        window.location.reload();
        return 
      }
    };

    fetchUsers();
  }, []);

  
      if(!currentUser) {
       navigate('/');
       window.location.reload();
       return 
      }

   if (listUsers) {
     return (
    <>
    <div className='page-container'>

      <div className={navBar ? '' : ''}>
      <NavBar  title="Manager" className='navbar1' />
      </div>
          
   
     
        
       <div className='content-wrap'>
       <ListUsersBody />
       </div> 


      <div className={navBar ? '' : ''}>
      <Footer/>
      </div>   
    
    </div>
    </>
  );
   } else {
    return <Spinner/>
   }
}

export default ListUsers;
